import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/mappa-overlay.css";
import "@/censisci-luogo.css";
import "@/brochure-theme.css";
import "@/spatial-templates.css";
import "@/borgo-spatial.css";
import "@/emergenza-regola-secondo.css";
import "@/protocollo-elite.css";
import "@/impronta.css";
import "@/mobile-app.css";
import "@/design-protocol.css";
import "@/unified-search.css";
import "@/map-quick-access.css";
import "@/comune-territory-map.css";
import "@/comune-common-layout.css";
import "./styles/italia-editorial.css";
import "@/admin-readable-theme.css";
import "@/site-readability.css";
import "@/cicerone-home.css";
import "@/full-immersion.css";
import "@/home-campli.css";
import "@/nodo-zero.css";
import "@/chatbox-storico.css";
import "@/scheda-qr.css";
import "@/mobile-map.css";
import "@/mobile-layout.css";
import "@/comune-pilot-layout.css";
import "@/piazza-parchment.css";
import "@/global_styles.css";
import axios from "axios";
import { handleAdminAuthError } from "./utils/adminAuth";
import { primeSpeechVoicesCatalog } from "./utils/ttsVoice";
import App from "@/App";
import "@/future-glass.css";

// Pre-carica voci TTS internazionali (IT, EN, FR…) appena disponibile speechSynthesis
primeSpeechVoicesCatalog();

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    handleAdminAuthError(error);
    return Promise.reject(error);
  },
);

// Render sincrono: nessun await prima della UI — errori API gestiti nei componenti.
// PWA: service worker solo in produzione (abilita "Installa app")
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
